import { Component } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router"; // import Router and NavigationEnd
import { filter } from "rxjs/operators";
import { environment } from "../environments/environment";
import { DataStore } from "./shared/data-store.service";
import { TokenService } from "./core/tokenManagement/token.service";
declare let gtag: Function;
declare let fbq: Function;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent {
  title = "app";

  constructor(
    router: Router,
    private dataservice: DataStore,
    private tokenService: TokenService,
  ) {
    // this.persistCountryData();
    const navEndEvents = router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
    );

    // navEndEvents.subscribe((event: NavigationEnd) => {
    //   gtag(
    //     "config",
    //     "UA-177219090-1",
    //     {
    //       page_path: event.urlAfterRedirects,
    //     }
    //     // fbq("track", "PageView")
    //   );
    // });
  }

  getAccessToken() {
    this.tokenService.getAccessToken();
  }

  //at anypoint in time whether on page reload our data store will still be updated with the locally stored data
  persistCountryData() {
    let userData = JSON.parse(localStorage.getItem("_usr_d"));
    if (userData) {
      let country =
        userData["country"] == "GHA" ? environment.ghBaseUrl : environment.url;
      this.dataservice.updateBaseUrl(country);
    }
  }
}
